<template>
  <div class="wrapper">
    <perfect-scrollbar :options="scroll_options" id="app">
      <router-view></router-view>
    </perfect-scrollbar>
  </div>
</template>
<script>
export default {
  name: "App",
  metaInfo: {
    changed(metaInfo) {
      const locale = navigator.language || navigator.userLanguage;
      if (locale.indexOf('CA') < 0) {
        //page info GA logging
        gtag('config', process.env.VUE_APP_GA_ID, {
          'page_title' : metaInfo.title
        });
      }
    }
  },
  data() {
    return {
      scroll_options: {
        suppressScrollX: false
      },
      focus: 0
    }
  },
  mounted() {
    document.cookie = "same-site-cookie=foo; SameSite=Lax";
    document.cookie = "cross-site-cookie=bar; SameSite=None; Secure";
    window.addEventListener("keyup", e => {
      if ([38, 40, 37, 39, 0x25, 0x26, 0x27, 0x28].includes(e.keyCode)) {
        let focusList = document.querySelectorAll('.focusable')
        //console.log(focusList)
        switch (e.keyCode) {
          case 0x25: //left
          case 0x26: //up
          case 37:   //left
          case 38:   //up
            this.focus--
            break;
          case 0x27: //right
          case 0x28: //down
          case 39:   //right
          case 40:   //down
            this.focus++
            break;
        }
        if (this.focus < 0) this.focus = focusList.length - 1
        else if (this.focus > focusList.length - 1) this.focus = 0
        //console.log(this.focus)
        focusList[this.focus].focus();
      }
      if (e.keyCode === 461 || e.keyCode === 0x1CD) {
        let back = '';
        switch (this.$route.name) {
          case 'Login':
          case 'QrLogin':
            back = 'Home'
            break;
          case 'LgLogin':
            back = 'Login'
            break;
        }
        if ('Home' === this.$route.name) {
          if (window.PalmSystem && window.PalmSystem.platformBack) return window.PalmSystem.platformBack()
        }
        if (back && 'Login' !== this.$route.name) {
          this.$router.push({
            name: back
          });
        }
      }
    });
  },
  updated() {
    this.focus = 0
  }
};
</script>
<style>
*:focus {
  outline: none;
}

.off {
  opacity: 0.2 !important;
}

.hid {
  display: none !important;
}

.ps {
  overflow-x: hidden;
}

.ps__rail-y {
  z-index: 1030;
}

.footer_control {
  background-color: #fff;
  height: 60px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.invisible {
  visibility: hidden !important;
}

.hidden-ti-up {
  display: none !important;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #ffffff;
}

.nav-item a:hover {
  color: #acf8ff;
  text-decoration: underline;
  text-decoration: none;
}

@media (max-width: 100px) {
  .hidden-ti-down {
    display: none !important;
  }
}

@media (min-width: 575px) {
  .hidden-xs-up {
    display: none !important;
  }
}

@media (max-width: 575px) {
  .hidden-xs-down {
    display: none !important;
  }
}

@media (min-width: 576px) {
  .hidden-sm-up {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .hidden-sm-down {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .hidden-md-up {
    display: none !important;
  }
}

@media (max-width: 991px) {
  .hidden-md-down {
    display: none !important;
  }
}

@media (min-width: 992px) {
  .hidden-lg-up {
    display: none !important;
  }
}

@media (max-width: 1199px) {
  .hidden-lg-down {
    display: none !important;
  }
}

@media (min-width: 1200px) {
  .hidden-xl-up {
    display: none !important;
  }
}

.hidden-xl-down {
  display: none !important;
}

.visible-print-block {
  display: none !important;
}

@media print {
  .visible-print-block {
    display: block !important;
  }
}

.visible-print-inline {
  display: none !important;
}

@media print {
  .visible-print-inline {
    display: inline !important;
  }
}

.visible-print-inline-block {
  display: none !important;
}

@media print {
  .visible-print-inline-block {
    display: inline-block !important;
  }
}

@media print {
  .hidden-print {
    display: none !important;
  }
}

</style>